/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2022-11-18 10:50:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-09 15:25:05
 * @FilePath: \ep-admin-management\src\config\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 *  @description: api配置
 */

let _BASE // API接口地址前缀
let _DownloadBase // 下载接口地址前缀
let _StaticBase // 静态资源地址
let _H5Base // h5页面的前缀
let _GoogleApiKey // 谷歌地图API KEY
let _HPP_URL // HPPURL
switch (import.meta.env.MODE) {
  case 'production':
    // 生产地址
    _BASE = window.location.origin + '/mapi'
    _DownloadBase = window.location.origin
    _StaticBase = window.location.origin + '/INTELb2bPro'
    _GoogleApiKey = 'AIzaSyAsocStQY8Fn6hqg82CJTDYCj4j1Xh55QI'
    break

  // case 'uat':
  //     // uat环境地址
  //     _BASE = window.location.origin + '/mapi';
  //     _DownloadBase = window.location.origin;
  //   _StaticBase = window.location.origin + '/INTELb2bUat';
  //   break;

  // case 'test':
  //     // 测试环境地址
  //     _BASE = window.location.origin + '/mapi';
  //     _DownloadBase = window.location.origin;
  //   _StaticBase = window.location.origin + '/INTELb2bTest';
  //   break;
  case 'share:tst':
    // 本地开发走代理
    _BASE = '/api'
    // _BASE_URL = 'https://test-portalinterface.hikvision.com/epartnerApi'
    _StaticBase = 'https://test-portalinterface.hikvision.com/apptest/share'
    _HPP_URL = 'https://hpc-sgp-uat-5.hik-partner.com'
    break
  case 'share:dev':
    // 测试环境
    _BASE = 'https://test-portalinterface.hikvision.com/epartnerApi'
    _StaticBase = 'https://test-portalinterface.hikvision.com/INTELb2bTest'
    _HPP_URL = 'https://hpc-sgp-uat-5.hik-partner.com'
    break
  case 'share:uat':
    // uat环境
    _BASE = 'https://uat-portalinterface.hikvision.com/epartnerApi'
    _StaticBase = 'https://portal-uat.hikvision.com/INTELb2bUat'
    _HPP_URL = 'https://hpc-sgp-uat-9.hik-partner.com'
    break
  case 'share':
    // 生产地址
    _BASE = 'https://la-epartner.hikvision.com/epartnerApi'
    _StaticBase = 'https://la-epartner.hikvision.com/INTELb2bPro'
    _HPP_URL = 'https://isgp.hik-partner.com'
    break

  default:
    // 本地联调环境
    // _BASE = 'https://portal-dev-admin.hikvision.com/mapi';
    _BASE = 'https://portal-test-admin.hikvision.com/mapi'
    // _DownloadBase = 'https://portal-test-admin.hikvision.com';
    //  _BASE = 'https://epadmin-uat.hikvision.com/mapi';
    _DownloadBase = 'https://portal-test-admin.hikvision.com'
    _StaticBase = 'https://portal-dev-admin.hikvision.com/INTELb2bTest'
    _GoogleApiKey = 'AIzaSyBiVFz5Q1x5mRvFLuo-X84gaXqYpV0XZac'
    //_StaticBase = 'https://portal-test-admin.hikvision.com/INTELb2bTest';
    break
}


export const BASE = _BASE
export const DownloadBase = _DownloadBase
export const StaticBase = _StaticBase
export const H5Base = _H5Base
export const GoogleApiKey = _GoogleApiKey
export const HPP_URL = _HPP_URL
